/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // 倒计时
  function getRandomNum(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }

  let endTimeG;

  function cutDownTime() {
    let nowTime = new Date();
    let endTime = new Date(endTimeG);

    let leftTime = endTime.getTime() - nowTime.getTime();
    if (leftTime < 0) {
      setupNewCountdown();
      leftTime = 0;
    }
    let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
      leftM = Math.floor((leftTime / (1000 * 60)) % 60),
      leftS = Math.floor((leftTime / 1000) % 60);
    leftH = leftH >= 10 ? leftH : "0" + leftH;
    leftM = leftM >= 10 ? leftM : "0" + leftM;
    leftS = leftS >= 10 ? leftS : "0" + leftS;

    return {
      hour: leftH,
      minute: leftM,
      second: leftS,
    };
  }
  function setupNewCountdown() {
    const randomHour = getRandomNum(1, 9);
    const currentTime = new Date();
    endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
  }
  let intervalId;

  function getCutDownTime() {
    setupNewCountdown();
    if (intervalId) clearInterval(intervalId);
    intervalId = setInterval(function () {
      let cutDownTimeText = cutDownTime();
      $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
      $(".sp_top_cut_down .sp_left_view .sp_minute").html(
        cutDownTimeText.minute
      );
      $(".sp_top_cut_down .sp_left_view .sp_second").html(
        cutDownTimeText.second
      );
    }, 1000);
  }

  getCutDownTime();

  let spImgList = [
    "https://cdn.shopify.com/s/files/1/0624/0292/0612/files/202505142-p1.png",

    "https://cdn.shopify.com/s/files/1/0624/0292/0612/files/202505142-c1.png",
    "https://cdn.shopify.com/s/files/1/0624/0292/0612/files/202505142-c2.png",
    "https://cdn.shopify.com/s/files/1/0624/0292/0612/files/202505142-c3.png",
    "https://cdn.shopify.com/s/files/1/0624/0292/0612/files/202505142-c4.png",
    "https://cdn.shopify.com/s/files/1/0624/0292/0612/files/202505142-c5.png",
  ];

  new Swiper("#sp-swiper2", {
    autoplay: true,
    autoplay: {
      disableOnInteraction: false,
    },
    spaceBetween: 0,
    slidesPerView: "auto",
    centeredSlides: true,
    loop: true,
    pagination: {
      el: ".sp-pagination1",
      clickable: true,
    },
  });
  function mainRender() {
    $(function () {
      $("#root").css("zoom", "normal");
      let scale = document.body.clientWidth / 1080;
      $("#root").css("zoom", scale);

      window.addEventListener(
        "resize",
        (function () {
          var timer;
          return function () {
            if (timer) clearTimeout(timer);
            timer = setTimeout(function () {
              $("#root").css("zoom", "normal");
              let scale = document.body.clientWidth / 1080;
              $("#root").css("zoom", scale);
            }, 100);
          };
        })()
      );
    });

    function lazyLoadImages() {
      // 懒加载
      const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
      const config = {
        rootMargin: "0px 0px 1300px 0px",
        threshold: 0,
      };

      const lazyLoadObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            // 当图片进入视口时
            const image = entry.target;
            const dataSrc = image.getAttribute("data-src");
            image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
            lazyLoadObserver.unobserve(image); // 停止观察该图片
          }
        });
      },
      config);

      images.forEach(function (image) {
        lazyLoadObserver.observe(image); // 开始观察每个图片
      });
    }

    function preloadImages(imageArray) {
      // 预加载
      // 检查数组数据结构
      if (Array.isArray(imageArray[0])) {
        // 处理二维数组
        imageArray.forEach((subArray) => {
          subArray.forEach((url) => {
            const img = new Image();
            img.src = url;
          });
        });
      } else {
        // 处理一维数组
        imageArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      }
    }

    lazyLoadImages();

    preloadImages(spImgList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        let _topHeight =
          $(".time-part").height() + $(".sp-header-top").height() - 10;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            _topHeight * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });

    // IOS字体多了间距的处理 给节点添加 sp_system 类名
    // 判断当前用户是安卓端还是iOS端
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    var isAndroid = /android/i.test(userAgent);
    var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

    if (isAndroid) {
      console.log("Android");
    } else if (isIOS) {
      console.log("iOS");
    } else if (isPC) {
      console.log("PC");
    } else {
      $(".sp_system").css("letter-spacing", "-4px");
    }
  }

  mainRender();

//   let sp_price1 = 29.99;
//   let sp_price2 = 49.99;

//   function calcTotal(price, num) {
//     let _result = Number(price) * Number(num);

//     return _result.toFixed(2);
//   }

//   $(".sp-reduce").click(function () {
//     let input = $(this).siblings("input")[0];
//     let num = Number(input.value) - 1;
//     if (num > 0) {
//       input.value = num;
//     }
//     // $("#sp_price1").html(calcTotal(sp_price1, input.value));
//     // $("#sp_price2").html(calcTotal(sp_price2, input.value));
//   });
//   $(".sp-add").click(function () {
//     let input = $(this).siblings("input")[0];
//     let num = Number(input.value) + 1;
//     input.value = num;
//     // $("#sp_price1").html(calcTotal(sp_price1, input.value));
//     // $("#sp_price2").html(calcTotal(sp_price2, input.value));
//   });
//   let spProList = ["https://cdn.shopify.com/s/files/1/0624/0292/0612/files/202505142-p1-s.png", "https://cdn.shopify.com/s/files/1/0624/0292/0612/files/202505142-p2-s.png"];
//   $(".product-box .sp-opt").click(function () {
//     $(this).siblings().removeClass("active");
//     $(this).addClass("active");
//     let _index = $(this).index();

//     $(this).parents(".product-box").find(".sp-p-pro")[0].src =
//       spProList[_index];
//   });
//   $('.sp-btn-style').click(function(){
//     let num = $(this).siblings('.addGroup').find('input').val()
//     num == undefined ? num = 1 : ''
//     let id = $(this).parents().siblings('.product-box').find('.sp-opt.active').attr('data-id')
//     console.log(id)
//     window.location.href = '/cart/' + id + ':' + num
//   })
  let _swiper = new Swiper(".sp-swiper-p1", {
    spaceBetween: 10,
    speed: 1,
  });
  let _swiper2 = new Swiper(".sp-swiper-p2", {
    spaceBetween: 10,
    speed: 1,
  });
  // 展示尺码弹窗
  $(".sp-btn-pop").click(function () {
    $(".sp-mask").css("display", "flex");
    // $(".sp-pop").show();
  });
  // 关闭弹窗按钮

  $(".sp-close-btn").click(function (e) {
    $(".sp-mask").hide();
    // $(".sp-pop").hide();
  });
 function calcTotal(price, num) {
    let result = Number(price) * Number(num);
    return result.toFixed(2);
  }

  let prods = window.product;
    function getCur(target) {
    let color = target.find("#sp-color div.active").attr("data-val");
    let type = target.find("#sp-type div.active").attr("data-val");

    return prods.filter((item) => item.option1 == color  && item.option2 == type)[0];
    }
    function changePrice() {
       const target = $('.product-part')
       
    let num = $("#calcNumber").val();
    let price = (getCur(target).price * num / 100).toFixed(2)
    let compare = (getCur(target).compare_at_price * num / 100).toFixed(2)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    $(".product-part .price-group #sp_price1").html(price);
    $(".product-part .price-group #sp_price2").html(compare);
    let off_font =
    100 - Math.ceil((getCur(target).price / getCur(target).compare_at_price) * 100);
    $(".product-part .sp-row p span").html(off_font);
    }

  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    if (num > 0) {
      input.value = num;
    }
    changePrice()
  });
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    changePrice()
  });

  let sptext1 = [
    "Black",
    "White",
    "Black+ (80 Pieces-Leather Care Wipes)",
    "White+ (80 Pieces-Leather Care Wipes)",
  ];
  let sptext2 = ["Premium", "Standard"];
  let sptext3 = ["BUY 1 PC", "BUY 2 PCS（Save $10）"];

  $(".sp-option").click(function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    const target = $(this).parents(".product-part")
    let colorOptions = target.find("#sp-color .sp-option.active").index();
    let typeOptions = target.find("#sp-type .sp-option.active").index();
    if(colorOptions>=2){
      colorOptions=colorOptions-2
    }
    target.find("#spName1").html(target.find("#sp-color .sp-option.active").attr("data-val"));
    target.find("#spName2").html(target.find("#sp-type .sp-option.active").attr("data-val"));
     _index = colorOptions + typeOptions * 2
     console.log('ssssssssssss++++', _index);
     
    _swiper.slideToLoop(_index);
    _swiper2.slideToLoop(_index);
    changePrice()
  });

  $('.sp-btn-style').click(function(){
     const target = $(this).parents(".product-part")
      let num = target.find('#calcNumber').val()
      let id = getCur(target).id
      window.location.href = '/cart/' + id + ':' + num
  })
   $(function () {
    // 购物车加购动效
    $(".cart-btn").click(function () {
      $(this).children("img").addClass("on");
      $(".sp-header-top .sp-cart .num").show();
      setTimeout(function () {
        $(".cart-btn").children("img").removeClass("on");
      }, 500);
      $(".sp-header-top .sp-cart").addClass("on");
      setTimeout(function () {
        $(".sp-header-top .sp-cart").removeClass("on");
      }, 500);
    });

    let initNum = 0;
    $(".product-part .cart-btn").click(function () {
       const target = $(this).parents(".product-part")
      var data = {
        id: getCur(target).id,
        quantity: $('#calcNumber').val(),
      };
      // var img = $(".product-part .swiper-slide-active .sp-img");
        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: data,
          success: function () {
            $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
              $("#cardNum").html(result.item_count);
              $("#cardNum").removeClass("sp-gray");
            });
          },
          dataType: "json",
        });
      
      // handleAddToCart(initNum);

      var imgs = $(this).parents(".product-part").find(".swiper-slide-active").find("img");

      imgs.each(function () {
        var $img = $(this);
        var flyer = $img[0].cloneNode(true);
        flyer.classList.add("sp_clone");

        $(this).parents(".product-part").append(flyer);

        $(flyer).css({
          width: $img[0].width,
          height: $img[0].height,
          background: "#e7e9ef",
          position: "fixed",
          top: $img[0].getBoundingClientRect().top,
          left: $img.offset().left,
          "z-index": 99,
        });

        let finish = $(".sp-cart");
        $(flyer).animate(
          {
            top: finish[0].offsetTop + $(".time-part").height(),
            left: finish[0].offsetLeft + finish.width() / 2,
            width: 50,
            height: 50,
            opacity: 0.4,
          },
          500,
          "linear",
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach();
              }
            );
          }
        );
      });
    });
  });
  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }
});
